import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FONTS } from 'utils/styles/fonts';
import { STYLE_FRAGMENTS } from 'utils/styles/animation';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StartButtonWithAnimation = ({ background, handleClick }) => (
  <Wrapper className="startButtonWithAnimation" background={background}>
    <button onClick={handleClick} className="button" type="button">
        Start Your Trip
    </button>
  </Wrapper>
);

StartButtonWithAnimation.defaultProps = {
  background: COLORS.blue,  
};

StartButtonWithAnimation.propTypes = {
  background: PropTypes.string,
};

const Wrapper = styled.div`
  height: max-content;
  ${FLEX_CONTAINER.FlexCenterRow}

  .button {
    ${FONTS.font24}
    color: ${COLORS.white};
    min-width: 351px;
    min-height: 92px;
    border: none;
    border-radius: 30px;
    transition: all 0.3s ease-in-out 0s;
    outline: none;
    position: relative;
    padding: 10px;
    filter: drop-shadow(7px 9px 15px rgba(0, 0, 0, 0.25));
    cursor: pointer;

    ${({ background }) =>
    background === 'yellow'
      ? STYLE_FRAGMENTS.animationButtonYellow.button
      : STYLE_FRAGMENTS.animationButtonBlue.button};
    animation: clock 1.8s infinite;

    @media ${deviceMax.laptopM} {
      min-width: 218px;
      min-height: 54px;
      border-radius: 20px;
      ${FONTS.font16}
    }
  }

  button::before {
    content: '';
    border-radius: 30px;
    min-width: calc(393px + 12px);
    min-height: calc(103px + 12px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: all 0.3s ease-in-out 0s;
    ${({ background }) =>
    background === 'yellow'
      ? STYLE_FRAGMENTS.animationButtonYellow.before
      : STYLE_FRAGMENTS.animationButtonBlue.before};

    @media ${deviceMax.laptopM} {
      min-width: calc(246px + 12px);
      min-height: calc(68px + 12px);
    }
  }

  .button:hover {
    color: ${COLORS.white};
    transform: translateY(-6px);
  }

  button:hover::before {
    opacity: 1;
  }

  button::after {
    content: '';
    width: 30px;
    height: 30px;
    border-radius: 100%;
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ background }) =>
    background === 'yellow'
      ? STYLE_FRAGMENTS.animationButtonYellow.after
      : STYLE_FRAGMENTS.animationButtonBlue.after};
    animation: ring 1.5s infinite;
  }

  button:hover::after {
    animation: none;
    display: none;
  }

  @keyframes ring {
    0% {
      width: 30px;
      height: 30px;
      opacity: 1;
    }
    100% {
      width: 393px;
      height: 393px;
      opacity: 0;
    }
  }

  @media ${deviceMax.tablet} {
    @keyframes ring {
      0% {
        width: 30px;
        height: 30px;
        opacity: 1;
      }
      100% {
        width: 300px;
        height: 300px;
        opacity: 0;
      }
    }
  }

  @keyframes clock {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;
